var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-4 has-background-white mb-0" }, [
    _c("nav", { staticClass: "level is-mobile" }, [
      _c("div", { staticClass: "level-left" }, [
        _vm.isSignable
          ? _c("div", { staticClass: "level-item is-hidden-mobile" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("addpila")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-plus fa-fw" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                  _vm._v(" Agregar para firmar"),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _vm.nivel >= 1
            ? _c(
                "a",
                {
                  staticClass: "button is-light",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("descargar")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-download fa-fw" }),
                  _vm._v(" Descargar"),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item" }, [
          _c(
            "a",
            {
              staticClass: "button is-light",
              on: {
                click: function ($event) {
                  return _vm.$emit("recargar")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-sync fa-fw" }), _vm._v(" Recargar")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "level-right" }, [
        _c(
          "div",
          { staticClass: "level-item" },
          [
            _c(
              "b-dropdown",
              {
                attrs: { "aria-role": "list", position: "is-bottom-left" },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function ({ active }) {
                      return _c("button", { staticClass: "button is-light" }, [
                        _vm._v("\r\n            Otras acciones "),
                        _c("i", {
                          staticClass: "fas fa-fw",
                          class: active ? "fa-chevron-up" : "fa-chevron-down",
                        }),
                      ])
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isSignable,
                        expression: "isSignable",
                      },
                    ],
                    staticClass:
                      "is-hidden-desktop has-text-primary has-text-weight-bold",
                    attrs: { "aria-role": "listitem" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("addpila")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus fa-fw" }),
                    _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                    _vm._v(" Agregar para firmar"),
                  ]
                ),
                _vm._v(" "),
                _vm.nivel >= 6
                  ? _c(
                      "b-dropdown-item",
                      {
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("moveDocument")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-dolly fa-fw" }),
                        _vm._v(" Mover"),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.nivel >= 6
                  ? _c(
                      "b-dropdown-item",
                      {
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("renameDocument")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-terminal fa-fw" }),
                        _vm._v(" Renombrar"),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.canPreview,
                        expression: "canPreview",
                      },
                    ],
                    staticClass: "is-hidden-touch",
                    attrs: { "aria-role": "listitem" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("side-by-side")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-columns fa-fw" }),
                    _vm._v(" Lado a lado"),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.canPreview,
                        expression: "canPreview",
                      },
                    ],
                    attrs: { "aria-role": "listitem" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("print")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-print fa-fw" }),
                    _vm._v(" Imprimir"),
                  ]
                ),
                _vm._v(" "),
                _vm.canDelete
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "has-text-danger",
                        attrs: { "aria-role": "listitem" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("deleteDocument")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-trash fa-fw" }),
                        _vm._v(" Eliminar"),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }